'use strict';
import template from './listadoObservadosMun.html';
import controller from './listadoObservadosMun.controller';

const listadoObservadosMunComponent = {
  controller,
  template
};

export default listadoObservadosMunComponent;


// WEBPACK FOOTER //
// ./src/app/components/listados/lista-observadoMun/listadoObservadosMun.component.js